exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-practitioner-components-nav-learning-styles__wrapper {\n  height:100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--cp-color-app-primary-dark-text);\n}\n\n.src-practitioner-components-nav-learning-styles__learningButton {\n  position: relative;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "src-practitioner-components-nav-learning-styles__wrapper",
	"learningButton": "src-practitioner-components-nav-learning-styles__learningButton"
};